import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { fadeIn, staggerContainer, textVariant } from "../utils/motion"; 
import { useTranslation } from "react-i18next";

const HowItWorks = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const steps = [
    {
      number: "1",
      title: t("howitworks.title"),
      description: t("howitworks.description")
    },
    {
      number: "2",
      title:  t("howitworks.title1") ,
      description:  t("howitworks.description")
    },
    {
      number: "3",
      title:  t("howitworks.title2"),
      description:  t("howitworks.description")
    }
  ];

  return (
    <motion.section
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.25 }}
      variants={staggerContainer()}
      className="bg-white dark:bg-[#706F6F] py-14 px-4"
    >
      <div className="max-w-6xl mx-auto text-center">
        <motion.h2 
          variants={textVariant(0.2)}
          className="text-4xl font-bold text-[#42AB3F] dark:text-[#42AB3F] mb-4"
        >
          {t("howitworks")}
        </motion.h2>
        
        <motion.p 
          variants={fadeIn("up", "spring", 0.3, 1)}
          className="text-gray-600 dark:text-gray-300 mb-12 max-w-2xl mx-auto"
        >
         {t("howitworks1")} 
        </motion.p>

        <motion.div 
          variants={staggerContainer(0.1, 0.1)}
          className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12"
        >
          {steps.map((step, index) => (
            <motion.div
              key={index}
              variants={fadeIn("up", "spring", index * 0.2, 0.75)}
              className="p-6 bg-gray-50 dark:bg-white rounded-2xl shadow-md"
              whileHover={{
                scale: 1.05,
                boxShadow: "0px 10px 25px rgba(0,0,0,0.1)",
                transition: { duration: 0.3 }
              }}
            >
              <motion.div 
                className="text-[#DA6E2f] dark:text-[#DA6E2f] text-3xl font-bold mb-4"
                whileHover={{ scale: 1.1 }}
              >
                {step.number}
              </motion.div>
              <h3 className="text-lg font-semibold text-gray-800 dark:text-black mb-2">
                {step.title}
              </h3>
              <p className="text-gray-600 dark:text-gray-600">
                {step.description}
              </p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div 
          variants={fadeIn("up", "spring", 0.6, 1)}
          className="flex items-center justify-center gap-6 flex-wrap"
        >
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => navigate("/check")}
            className="inline-block bg-[#DA6E2f] hover:bg-[#7c523a] text-white font-semibold px-6 py-3 rounded-xl shadow-md"
          >
            {t("here")}
          </motion.button>
          
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => navigate("/ChatBox")}
            className="inline-block bg-[#DA6E2f] hover:bg-[#7c523a] text-white font-semibold px-6 py-3 rounded-xl shadow-md"
          >
           {t("here1")}
          </motion.button>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default HowItWorks;